import React, { useState } from 'react';
import { FaChevronRight } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import type { ChatChangeReceipt } from '../../client';
import './ChatChangeReceipts.css';

export interface ChatChangeReceiptsProps {
  receipts: ChatChangeReceipt[];
}

const KIND_LABELS: Record<ChatChangeReceipt['kind'], string> = {
  project: 'Project',
  card: 'Card',
  wiki: 'Wiki Page',
  database: 'Database',
  chart: 'Chart',
  dashboard: 'Dashboard',
};

const ChatChangeReceipts: React.FC<ChatChangeReceiptsProps> = ({
  receipts,
}) => {
  const [expanded, setExpanded] = useState(false);
  if (receipts.length === 0) return null;

  const hiddenCount = Math.max(0, receipts.length - 3);
  const visible = expanded ? receipts : receipts.slice(0, 3);

  return (
    <div className="chat-change-receipts">
      <ul className="chat-change-receipt-list">
        {visible.map((receipt) => (
          <li key={receipt.id}>
            <Link className="chat-change-receipt" to={receipt.href}>
              <span className="chat-change-receipt-copy">
                <span className="chat-change-receipt-eyebrow">
                  {KIND_LABELS[receipt.kind]}{' '}
                  {receipt.action === 'created' ? 'Created' : 'Edited'}
                </span>
                <span
                  className="chat-change-receipt-title"
                  title={receipt.title}>
                  {receipt.title}
                </span>
              </span>
              <FaChevronRight
                className="chat-change-receipt-chevron"
                aria-hidden
              />
            </Link>
          </li>
        ))}
      </ul>
      {hiddenCount > 0 && (
        <button
          type="button"
          className="chat-change-receipts-toggle"
          aria-expanded={expanded}
          onClick={() => setExpanded((current) => !current)}>
          {expanded ? 'Show less' : `Show more (${hiddenCount})`}
        </button>
      )}
    </div>
  );
};

export default ChatChangeReceipts;
